'use client';

import React from 'react';

interface NoteStarsProps {
  propsNumberOfLogs: number;
}

/**
 * [共通]ノート数に応じた星
 * @param param0
 * @returns
 */
const NoteStars: React.FC<NoteStarsProps> = ({ propsNumberOfLogs }) => {
  return (
    <>
      {Number(propsNumberOfLogs) < 100 ? (
        <></>
      ) : Number(propsNumberOfLogs) < 600 ? (
        <div className="flex justify-start items-center">
          {Number(propsNumberOfLogs) >= 100 && <div className="star text-xs"></div>}
          {Number(propsNumberOfLogs) >= 200 && <div className="star text-xs"></div>}
          {Number(propsNumberOfLogs) >= 300 && <div className="star text-xs"></div>}
          {Number(propsNumberOfLogs) >= 400 && <div className="star text-xs"></div>}
          {Number(propsNumberOfLogs) >= 500 && <div className="star text-xs"></div>}
        </div>
      ) : (
        <div className="flex justify-start items-center">
          <div className="star-black text-base"></div>
        </div>
      )}
    </>
  );
};

export default NoteStars;
